__turbopack_context__.v({
  "Arrow": "_index-module__1C5Peq__Arrow",
  "Button": "_index-module__1C5Peq__Button",
  "Container": "_index-module__1C5Peq__Container",
  "Description": "_index-module__1C5Peq__Description",
  "Popup": "_index-module__1C5Peq__Popup",
  "Positioner": "_index-module__1C5Peq__Positioner",
  "Title": "_index-module__1C5Peq__Title",
});
